import { DefaultTheme } from 'styled-components';
import { dark as darkButton } from '../components/Button/theme';
import base from './base';
import { darkColors } from './colors';

const darkTheme: DefaultTheme = {
  ...base,
  isDark: true,
  colors: darkColors,
  button: darkButton
};

export default darkTheme;
